import config from "environment";
import { getRequest, postRequest } from "./client";
import { Tag, LinkView } from "winslow-core";
import { LinkAppConfig, LinkMetadata } from "../components/shares/types";
import {
  apiCreateTagPayload,
  apiGetMetadataPayload,
  apiUpdateTagNamePayload,
  apiCreateLinkViewPayload,
} from "./ShareService.types";

const { baseApi } = config;

// get one share
export async function apiGetTag(tagId: string): Promise<Tag | null> {
  const fetchURL = `${baseApi}/shares/tag/${tagId}`;
  return await getRequest(fetchURL, "API/apiGetTag");
}

export async function apiDeleteTag(tagId: string): Promise<Tag | null> {
  const fetchURL = `${baseApi}/shares/tag/delete/${tagId}`;
  return await getRequest(fetchURL, "API/apiDeleteTag");
}

export async function apiShareTag(tagId: string): Promise<Tag | null> {
  const fetchURL = `${baseApi}/shares/share-tag/${tagId}`;
  return await getRequest(fetchURL, "API/apiShareTag");
}

export async function apiUnshareTag(tagId: string): Promise<Tag | null> {
  const fetchURL = `${baseApi}/shares/unshare-tag/${tagId}`;
  return await getRequest(fetchURL, "API/apiUnshareTag");
}

export async function apiCreateTag(
  payload: apiCreateTagPayload
): Promise<Tag | null> {
  const fetchURL = `${baseApi}/shares/create-tag`;
  return await postRequest(fetchURL, payload, "API/apiCreateTag");
}

export async function apiGetSupportedApps(): Promise<LinkAppConfig[] | null> {
  const fetchURL = `${baseApi}/link/apps`;
  return await getRequest(fetchURL, "API/apiGetSupportedApps");
}

export async function apiGetMetadata(
  payload: apiGetMetadataPayload
): Promise<LinkMetadata | null> {
  const fetchURL = `${baseApi}/link/metadata`;
  return await postRequest(fetchURL, payload, "API/apiGetMetadata");
}

export async function apiGetWebsiteLinks(payload: {
  url: string;
  maxDepth: number;
  maxCount: number;
}): Promise<{
  links: string[];
  maxDepthMet: boolean;
  maxCountMet: boolean;
  errors?: string[];
}> {
  const fetchURL = `${baseApi}/link/website-links`;
  return await postRequest(fetchURL, payload, "API/apiGetWebsiteLinks");
}

export async function apiGetOtherApp(): Promise<LinkAppConfig | null> {
  const fetchURL = `${baseApi}/link/other-app`;
  return await getRequest(fetchURL, "API/apiGetOtherApp");
}

export async function apiUpdateTagName(
  payload: apiUpdateTagNamePayload
): Promise<Tag | null> {
  const fetchURL = `${baseApi}/shares/update-tag-name`;
  return await postRequest(fetchURL, payload, "API/apiUpdateTagName");
}

export async function apiCreateLinkView(
  payload: apiCreateLinkViewPayload
): Promise<LinkView> {
  const fetchURL = `${baseApi}/link/view-link`;
  return await postRequest(fetchURL, payload, "API/apiCreateLinkView");
}

export async function apiGetLinkViews(
  linkId: string
): Promise<LinkView[] | null> {
  const fetchURL = `${baseApi}/link/views/${linkId}`;
  return await getRequest(fetchURL, "API/apiGetLinkViews");
}
